// extracted by mini-css-extract-plugin
module.exports = {"replyButton":"_3q-1o","replyIcon":"_3Cwc9"};